export enum EditPageTab {
    Basics = "basics",
    Content = "content",
    Preview = "preview",
}
